var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":{name: 'google-workspace-gmail-index' }}},[_c('feather-icon',{attrs:{"size":"21","icon":"MailIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }